export default "__VITE_ASSET__CcMFF__A__"